module.exports = __webpack_public_path__ + "img/background030.137fb173.jpg";